import { Component, Inject, OnInit, ViewEncapsulation } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-document-viewer',
  templateUrl: './document-viewer.component.html',
  styleUrls: ['./document-viewer.component.css'],
  encapsulation: ViewEncapsulation.None,
})
export class DocumentViewerComponent implements OnInit {
  isDownloadable: boolean = false;
  public isAudio: boolean = false;
  public isVideos: boolean = false;
  public isDocuments: boolean = false;
  public isPresentations: boolean = false;

  public isDocumentLoaded: boolean = false;
  public isDocumentError: boolean = false;

  private timeIntervalFrame: any = null;
  private documentMaxCheck: number = 0;

  constructor(
    private dialogRef: MatDialogRef<DocumentViewerComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  ngOnInit(): void {
    this.checkFileTypes();
    this.isDocLoaded();
  }

  checkFileTypes = () => {
    this.isAudio = this.data.isAudio;
    this.isVideos = this.data.isVideos;
    this.isDocuments = this.data.isDocuments;
    this.isPresentations = this.data.isPresentations;
    this.isDownloadable = this.data.isDownloadable;
  };

  isDocLoaded() {
    let _this = this;
    this.timeIntervalFrame = setInterval(() => {
      var el = document.getElementById('iframe');
      if (el) {
        clearInterval(this.timeIntervalFrame);
        // el.addEventListener('load', function () {
        //   el.addEventListener('load', function () {
        //     console.log("Load event: Iframe doc loaded.");
        //   }, true);
        // }, false);
      } else {
        this.documentMaxCheck += 1;
      }
      if (this.documentMaxCheck == 10) {
        clearInterval(this.timeIntervalFrame);
        this.documentMaxCheck = 0;
        this.documentLoadError();
      }
    }, 2000);
  }

  documentLoaded = (_event: any = null) => {
    this.isDocumentLoaded = true;
    if (this.isDocuments || this.isPresentations) {
      document
        .getElementsByClassName('overlay-popout-google')[0]
        .classList.add('loaded');
    }
  };

  documentLoadError = (_event?: any) => {
    console.log(_event);
    if (_event != undefined) {
      this.isDocumentLoaded = false;
      this.isDocumentError = true;
    } else {
      this.isDocumentLoaded = true;
      this.isDocumentError = false;
    }
  };

  closeDocumentViewer = () => {
    this.dialogRef.close();
  };
}
